import HoursDetailsPopUP from "../schoolAdminPortal/SchoolAdminPages/HoursDetailsPopUP";

export const HoursTableColumns = [
  {
    headerName: "Sports",
    field: "sportName",
    flex: 1,
    minWidth: 100,
    align: "center",
    headerAlign: "center",
    sortable: false,
    headerClassName: "table-header bold",
    renderCell: (params) => (
      <div className="d-flex-align-cent height-70 w-100">
        <p className="link-blue text-width-auto mg-auto">
          {params.row.sportName}
        </p>
      </div>
    ),
  },
  {
    field: "totalHoursPurchased",
    headerName: "Hours Purchased",
    headerAlign: "center",
    headerClassName: "table-header bold",
    flex: 1,
    minWidth: 150,
    align: "center",
    sortable: false,
    cellClassName: "custom-cell",
  },
  {
    field: "usedHours",
    headerName: "Hours Used",
    headerAlign: "center",
    headerClassName: "table-header bold",
    flex: 1,
    minWidth: 150,
    align: "center",
    sortable: false,
    cellClassName: "custom-cell",
    renderCell: (params) => (
      <div>
        <span>{params.row.usedHours.toFixed(3)}</span>
      </div>
    ),
  },
  {
    field: "totalHoursAvailable",
    headerName: "Hours Available",
    headerAlign: "center",
    headerClassName: "table-header bold",
    flex: 1,
    minWidth: 150,
    align: "center",
    sortable: false,
    cellClassName: "custom-cell",
    renderCell: (params) => (
      <div>
        <span>{params.row.totalHoursAvailable.toFixed(3)}</span>
      </div>
    ),
  },
  {
    field: "BuyAdditionalHours",
    headerName: "Buy Additional Hours",
    headerAlign: "center",
    headerClassName: "table-header bold",
    flex: 1,
    minWidth: 150,
    align: "center",
    sortable: false,
    cellClassName: "custom-cell",
    renderCell: (params) => <HoursDetailsPopUP rowData={params.row} />,
  },
];
